import loadingImage from '../../../assets/loading.png';
import './loading.css';

export const Loading = ({ label }) => {
  return (
    <div className="container">
      <div className="iconContainer">
        <img src={loadingImage} alt="Loading" />
      </div>
      <div className="labelContainer">{label}</div>
    </div>
  );
};
